import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const ProductOffer = (_param)=>{
    var { title , description , imageUrl , fallbackImageUrl , linkTarget , url , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "title",
        "description",
        "imageUrl",
        "fallbackImageUrl",
        "linkTarget",
        "url",
        "className"
    ]);
    const sharedProps = {
        className: classnames('product-offer__image', {
            'product-offer__image--fallback': !imageUrl
        }),
        'data-t': 'ImageContainer'
    };
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('product-offer', className)
    }), url ? /*#__PURE__*/ React.createElement("a", {
        href: url,
        "data-t": "ImageAnchor",
        target: linkTarget,
        rel: linkTarget === '_blank' ? 'noreferrer noopener' : undefined
    }, /*#__PURE__*/ React.createElement("span", swcHelpers.extends({}, sharedProps), /*#__PURE__*/ React.createElement("img", {
        src: imageUrl !== null && imageUrl !== void 0 ? imageUrl : fallbackImageUrl,
        "data-t": "Image",
        alt: title
    }))) : /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, sharedProps), /*#__PURE__*/ React.createElement("img", {
        src: imageUrl !== null && imageUrl !== void 0 ? imageUrl : fallbackImageUrl,
        "data-t": "Image",
        alt: title
    })), /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "subheading1",
        className: "product-offer__title"
    }, url ? /*#__PURE__*/ React.createElement("a", {
        href: url,
        "data-t": "TitleAnchor",
        target: linkTarget,
        rel: linkTarget === '_blank' ? 'noreferrer noopener' : undefined
    }, title) : title), description && /*#__PURE__*/ React.createElement("p", null, description));
};
var ProductOffer$1 = ProductOffer;

export { ProductOffer$1 as default };
//# sourceMappingURL=ProductOffer.js.map
